<script>
export default {
  name: "NotFound"
}
</script>

<template>
<div class="main">
  <v-card class="card">
    <v-card-title>Page not found!</v-card-title>
    <v-card-text>This page could not be found. Press the button below to go to home.</v-card-text>
    <v-card-actions class="flex justify-center">
      <v-btn link to="/home">Home</v-btn>
    </v-card-actions>
  </v-card>
</div>
</template>

<style scoped>
.main{
  background: transparent;
  height: 100vh;
}
.card{
  border-radius: 12px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.99);
  padding: 0.3rem;
  margin: 2rem auto;
  max-width: 18rem;
  text-align: center;
}
</style>